<template>
  <div id="performer">

    <div class="performerinfo">
      <div class="performerinfo__profile" v-html="selfIntroduction">
      </div>
    </div>

    <div class="container is-max-desktop">

      <div class="recentlive">
        <div class="recentlive__content" v-if="Boolean(recentLives.length)" @click="liveTileClicked(recentLives[0].id, 'recentLive')">
          <div class="thumbnail">
            <b-image class="image" :src="recentLives[0].thumbnailURL" ratio="400by216" />
          </div>
          <div class="information">
            <div class="information__content">
              <p class="icon">配信中</p>
              <p class="title">{{recentLives[0].title}}</p>
              <p class="date">配信開始：{{format(recentLives[0].startAt)}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="upComingLive">
        <div class="upComingLive__header">配信予定</div>
        <ul class="columns is-multiline is-mobile">
          <LiveListedTile
            v-for="live in upComingLives"
            :key="live.id"
            :tileData="{
              liveId: live.id,
              imageSrc: live.thumbnailURL,
              nickname: live.performerNickname,
              genre: live.categories,
              startAt: live.startAt,
              title: live.title,
              type: 'upComingLive'
            }"
            :onClick="liveTileClicked"
          />
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import * as DateTime from '@/utils/date';
import LiveListedTile from '@/components/Molecules/LiveListedTile';
import { analyticsLog } from '@/utils/analytics';

export default {
  name: 'Performer',
  components: {
    LiveListedTile
  },
  computed: {
    ...mapState({
      nickname: state => state.performer.nickname,
      selfIntroduction: state => state.performer.selfIntroduction,
      upComingLives: state => state.live.upComingLives,
      recentLives: state => state.live.recentLives,
      photoURL: state => {
        return state.performer.photoURL
          ? state.performer.photoURL
          : 'https://firebasestorage.googleapis.com/v0/b/pandora-988f8.appspot.com/o/all%2Fdefault-user-icon.png?alt=media&token=4a1a4307-1990-4c99-a944-9b8d289e1a50';
      }
    })
  },
  async created() {
    await this.$store.dispatch(
      'performer/loadPerformerDoc',
      this.$route.params.userId
    );
    await this.$store.dispatch('live/loadUpComingLivesByUserId', {
      userId: this.$route.params.userId,
      limit: 1000
    });

    await this.$store.dispatch('live/loadRecentLivesByUserId', {
      userId: this.$route.params.userId,
      limit: 1
    });
    analyticsLog('出演者画面【表示時】', {'キャストID': this.$route.params.userId});
  },
  methods: {
    format(date) {
      return DateTime.formatJSDate('yyyy/MM/dd HH:mm', date);
    },
    liveTileClicked(id, type) {
      const path = `/live/streaming/${id}?type=${type}`;
      this.$router.push(path);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/performer.scss';
.like-icon-container {
  color: red;
  cursor: pointer;
  width: fit-content;
  margin: auto;
}
</style>

<style lang="scss">
@import '../assets/scss/profile.scss';
</style>
